pricelist = window.pricelist || {};

pricelist.form = {
	init: function() {
		var $priceList = $('form#priceList');

		$priceList.ajaxForm({
			dataType : 'json',
			success : function(responseText, statusText, xhr, $form) {
				var className = (responseText.success) ? 'success' : 'error';
				moya.message.growl(responseText.msg, className);
				if (responseText.items) {
					console.log(responseText.items);
					var $sortable = $('.sortable', $priceList);
					$sortable.empty();
					$sortable.append(responseText.items);
				}
			}
		});

		$('.add-line', $priceList).click(function () {
			var $new = $('.sortable >li:last', $priceList).clone(),
				timestamp = new Date().getTime();

			$new.find('input')
				.attr('value','')
				.removeAttr('id');

			$new.find('li:nth-child(1) input')
				.attr('name', 'data[' + timestamp + '][col1]');
			$new.find('li:nth-child(2) input')
				.attr('name', 'data[' + timestamp + '][col2]');
			$new.find('li:nth-child(3) input')
				.attr('name', 'data[' + timestamp + '][col3]');
			$new.find('li:nth-child(4) input')
				.attr('name', 'data[' + timestamp + '][col4]');
			$new.find('li:nth-child(5) input')
				.attr('name', 'data[' + timestamp + '][col5]');
			$new.find('li:nth-child(6) input')
				.attr('name', 'data[' + timestamp + '][col6]');

			$('.sortable', $priceList).append($new);
			$new.find('li:first-child input').focus();
			return false;
		});
	}
};

pricelist.front = {
	init: function() {
		var $priceList = $('#pricelist');
		if($priceList.length === 0){
			return;
		}
		$priceList.find('.categoryTop h2').click(function() {
			$(this).parent().toggleClass('open');
		});

		pricelist.front.setHeight();
		$(window).resize(function() {
			pricelist.front.setHeight();
		});

		$('a.print', $priceList).on('click', function() {
			$('.categoryTop', $priceList).addClass('noprint');
			$(this).parents('.categoryTop').removeClass('noprint');
			window.print();
		});
	},

	setHeight:function() {
		var $priceList = $('#pricelist');
		$('.categoryTop > .category > .content', $priceList).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	view:function() {
		var $priceList = $('#pricelist');
		$('a.print', $priceList).on('click', function() {
			window.print();
		});
	}
};
